<template>
	<div class="home-banner">
		<div class="home-banner-container">
			<div class="home-banner-commerce">
				<commerce-info
					:commerce="commerce"
				></commerce-info>
			</div>
			<div class="home-banner-items" id="banner-size">
				<div
					class="home-banner-items-container"
					:style="`transform: translateX(${translateValue}px)`"
				>
					<template v-for="banner in banners">
						<home-banner-item
							:key="banner.id"
							:banner="banner"
						></home-banner-item>
					</template>
				</div>
				<div class="home-banner-items-social">
					<a
						v-for="social in commerce.social"
						class="home-banner-items-social-btn href-depressed"
						:class="social.name"
						:style="`background: ${social.background}`"
						:href="social.link"
						:key="social.id"
						target="_blank"
					>
						<img
							:src="social.logo"
							:alt="social.name"
							:height="social.height"
						/>
					</a>
				</div>
				<div class="home-banner-items-indicators">
					<button
						v-for="(indicator, index) in banners.length"
						:key="index"
						class="home-banner-items-indicator"
						:class="{ 'active' : index === banners.findIndex(b => b.active) }"
						@click="$emit('change-banner', index)"
					>
						<div class="home-banner-items-indicator-symbol"></div>
					</button>
				</div>
			</div>
		</div>
		<categories-selector
			:categories="categories"
			full-image
			:scroll-active="scrollActive"
			:show-all="showAll"
			@selected-all="$emit('selected-all')"
			@selected-category="$emit('selected-category', $event)"
		></categories-selector>
	</div>
</template>

<script>
	import categoriesSelector from '@/components/market-place/categories-selector';
	import commerceInfo from '@/components/market-place/commerce-info';
	import homeBannerItem from '@/components/market-place/home-store/home-banner-item';

	export default {
		name: 'home-banner',
		components: {
			categoriesSelector,
			commerceInfo,
			homeBannerItem,
		},
		props: {
			banners: {
				default: () => [],
				type: Array,
			},
			categories: {
				default: () => [],
				type: Array,
			},
			commerce: {
				default: () => {},
				type: Object,
			},
			scrollActive: {
				default: false,
				type: Boolean,
			},
			showAll: {
				default: true,
				type: Boolean,
			},
			translateValue: [Number, String],
		},
	};
</script>

<style lang="scss" scoped>
	.home-banner {
		background-color: color(newbackground);
		min-height: calc(100vh + 210px);
		padding-bottom: 15px;

		&-container {
			margin: 0 auto;
			max-width: 1200px;
			position: relative;

			@media (min-width: 936px) {
				padding: 23px 0px 0px;
			}
		}

		@media (min-width: 936px) {
			min-height: 955px;
			padding-bottom: 41px;
		}

		&-items {
			margin-bottom: 33px;
			height: calc(100vh - 61px);
			overflow-x: hidden;
			position: relative;
			width: 100%;

			@media (min-width: 936px) {
				height: 627px;
			}

			&-container {
				display: flex;
				flex-direction: column;
				flex-wrap: wrap;
				height: 100%;
				position: relative;
				transition: all 1s ease-in-out;
				width: 100%;
			}

			&-indicators {
				bottom: 40px;
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				position: absolute;
				right: 0px;
				z-index: 1;

				@media (min-width: 936px) {
					right: 30px;
				}
			}

			&-indicator {
				border: 1px solid transparent;
				border-radius: 100%;
				height: 29px;
				margin: 0px 2px;
				width: 29px;

				&.active {
					border-color: color(white);
				}

				&-symbol {
					background-color: color(white);
					border-radius: 100%;
					height: 10px;
					margin: 0px auto;
					width: 10px;
				}
			}

			&-social {
				bottom: 0px;
				display: flex;
				flex-direction: column;
				flex-wrap: wrap;
				height: fit-content;
				height: -moz-fit-content;
				margin: auto;
				position: absolute;
				right: 0px;
				top: 0px;

				&-btn {
					border-bottom-left-radius: 10px;
					border-top-left-radius: 10px;
					color: color(white);
					height: 57px;
					line-height: 57px;
					margin: 5px 0px;
					text-align: center;
					transform: translateX(18px);
					transition: all .5s ease-in-out;
					width: 66px;

					&.instagram {
						background: #ff369c !important;
						background: -moz-radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%) !important;
						background: -webkit-radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%) !important;
						background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%) !important;
					}

					&:hover {
						transform: translateX(0px);
					}
				}
			}
		}

		&-commerce {
			background-color: color(white);
			border-bottom-left-radius: 20px;
			border-bottom-right-radius: 20px;
			box-shadow: 0 5px 11px 0 rgba(28, 28, 28, 0.5);
			left: 0px;
			margin: 0 auto;
			padding: 0px 18px 8px 38px;
			position: absolute;
			right: 0px;
			width: fit-content;
			width: -moz-fit-content;
			z-index: 1;

			@media (min-width: 936px) {
				padding: 6px 18px 8px 38px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/market-place/home-store/home-banner.vue